import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Typography,
  Button,
  Paper,
  Alert,
  Container,
  Box
} from '@mui/material';
import config from '../config';

const server_URL = config.SERVER_URL;

const Unsubscribed = () => {
  const { uid } = useParams();  // Changed from email to uid
  const [alert, setAlert] = useState({
    show: false,
    type: '',
    message: '',
  });
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [customerLogo, setCustomerLogo] = useState('');
  const [campaignName, setCampaignName] = useState('');

  // Fetch email address and customer info from uid
  React.useEffect(() => {
    const fetchEmailFromUid = async () => {
      try {
        const response = await fetch(`${server_URL}/tracker?uid=${uid}&get_email=true`, {
          method: 'GET',
        });
        const data = await response.json();
        console.log('Tracker response:', data);
        
        if (data.status === '1') {
          setEmail(data.email || '');
          setCustomerName(data.customer_name || '');
          setCustomerLogo(data.customer_logo || '');
          setCampaignName(data.campaign_name || '');
          
          console.log('Customer Name:', data.customer_name);
          console.log('Customer Logo URL:', data.customer_logo);
          console.log('Campaign Name:', data.campaign_name);
        } else {
          console.error('Failed to fetch email data:', data);
        }
      } catch (error) {
        console.error('Error fetching email from uid:', error);
      }


      try {
        const response = await fetch(`${server_URL}/unsubscribe/${uid}`, {
          method: 'GET',
        });
  
        const data = await response.json();
        console.log('Unsubscribe response:', data); 
      } catch (error) {
        console.error('Unsubscribe error:', error);
      }

    };

    if (uid) {
      fetchEmailFromUid();
    }
  }, [uid]);

  const handleSubscribe = async () => {
    if (!uid) {
      setAlert({
        show: true,
        type: 'error',
        message: 'Invalid subscription link. Please try again.'
      });
      return;
    }

    try {
      const response = await fetch(`${server_URL}/api/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uid }),
      });

      const data = await response.json();
      console.log('Subscribe response:', data);

      if (data.status === '1') {
        setSubscribed(true);
        setAlert({ show: false, type: '', message: '' });
      } else {
        setAlert({
          show: true,
          type: 'error',
          message: data.error || data.message || 'Failed to subscribe'
        });
      }
    } catch (error) {
      console.error('Subscribe error:', error);
      setAlert({
        show: true,
        type: 'error',
        message: 'An error occurred while processing your request'
      });
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          textAlign: 'center',
          borderRadius: 2,
          backgroundColor: 'white'
        }}
      >
        {/* Customer Logo */}
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center', minHeight: '120px', alignItems: 'center' }}>
          {customerLogo ? (
            <img 
              src={customerLogo} 
              alt={customerName || 'Customer Logo'} 
              style={{ 
                maxWidth: '200px', 
                maxHeight: '100px',
                objectFit: 'contain'
              }}
              onError={(e) => {
                console.error('Failed to load logo:', customerLogo);
                e.target.style.display = 'none';
                // Show fallback icon
                const parent = e.target.parentElement;
                if (parent) {
                  parent.innerHTML = `
                    <div style="
                      width: 120px; 
                      height: 120px; 
                      border-radius: 50%; 
                      background-color: #f0f0f0;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 48px;
                      color: #999;
                    ">📧</div>
                  `;
                }
              }}
            />
          ) : (
            <Box sx={{ 
              width: '120px', 
              height: '120px', 
              borderRadius: '50%', 
              bgcolor: '#f0f0f0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '48px',
              color: '#999'
            }}>
              📧
            </Box>
          )}
        </Box>
        
        {/* Customer Name */}
        <Typography variant="h5" sx={{ color: '#333', mb: 3, fontWeight: 600 }}>
          {customerName || 'Email Campaign'}
        </Typography>
        
        {alert.show && (
          <Alert 
            severity={alert.type} 
            sx={{ mb: 3 }}
            onClose={() => setAlert({ ...alert, show: false })}
          >
            {alert.message}
          </Alert>
        )}
        {subscribed ? (
          <>
            <Typography variant="h4" gutterBottom sx={{ color: '#333' }}>
              Thank you!
            </Typography>
            <Typography variant="body1" sx={{ color: '#666', mb: 2 }}>
              You have been successfully subscribed to our mailing list.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h4" gutterBottom sx={{ color: '#333' }}>
              Sorry to See You Go!
            </Typography>
            <Typography variant="body1" sx={{ color: '#666', mb: 2 }}>
              You have been successfully unsubscribed from our mailing list.
            </Typography>
            {/* {campaignName && (
              <Typography variant="body2" sx={{ color: '#999', mb: 2, fontStyle: 'italic' }}>
                Campaign: {campaignName}
              </Typography>
            )} */}
            <Typography variant="body1" sx={{ color: '#666', mb: 3 }}>
              If this was a mistake
            </Typography>
            <Button
              variant="contained"
              color="success"
              size="large"
              onClick={handleSubscribe}
              sx={{
                px: 4,
                py: 1,
                borderRadius: 1,
                textTransform: 'none',
                fontSize: '1rem'
              }}
            >
              Subscribe
            </Button>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default Unsubscribed; 